// extracted by mini-css-extract-plugin
export default {"titleSection":"wMnfu","image":"WglAu","pageHeader":"mvFPM","description":"sR4UG","buttons":"A13hk","navigation":"rajAO"};